import { Decorator } from '../decorator';

import type { DecoratedIconProps } from './decorated-icon-types';

export const DecoratedIcon: React.FC<DecoratedIconProps> = ({ children, decoration, className, decorationClassName, showDecoration }) => {
  return (
    <Decorator className={className} decoration={decoration} decorationClassName={decorationClassName} showDecoration={showDecoration}>
      {children}
    </Decorator>
  );
};
